import React from "react";
import { parseStyle, decodeStyle, mobile, tablet } from "../../../juntion";

function List({ id, db, gs, device }) {
	const data = db[id];

	const ps = parseStyle(data, gs, data.cstate);

	const tabletStyle = tablet(device) ? ps.tablet : {};
	const mobileStyle = mobile(device) ? ps.mobile : {};

	let input = ps.input;
	input = { ...input, ...(tablet(device) && ps.itablet) };
	input = { ...input, ...(mobile(device) && ps.imobile) };

	function renderChilds() {
		return input.textList.map((item, index) => {
			if (item !== "") {
				return (
					<li
						key={index}
						style={{
							marginBottom: input.itemGap - 0.5 + "rem",
						}}
					>
						{item}
					</li>
				);
			}
		});
	}

	const ss = decodeStyle(ps.style, gs);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
			}}
		>
			{input.listStyle.tag === "ul" && (
				<ul
					style={{
						...decodeStyle(ps.fixStyle, gs),
						...ss,
						...(tablet(device) && decodeStyle(tabletStyle, gs)),
						...(mobile(device) && decodeStyle(mobileStyle, gs)),
						// fontSize: "40px",
						lineHeight: ss.lineHeight,
						listStyleType: input.listStyle.style,
						listStylePosition: "inside",
					}}
				>
					{renderChilds()}
				</ul>
			)}
			{input.listStyle.tag === "ol" && (
				<ol
					type={input.listStyle.style}
					style={{
						...decodeStyle(ps.fixStyle, gs),
						...ss,
						// "&:hover": decodeStyle(ps.hover),
						...(tablet(device) && decodeStyle(tabletStyle, gs)),
						...(mobile(device) && decodeStyle(mobileStyle, gs)),
						// fontSize: "40px",
						lineHeight: ss.lineHeight,
						listStyleType: input.listStyle.style,
						listStylePosition: "inside",
					}}
				>
					{renderChilds()}
				</ol>
			)}
		</div>
	);
}

export default List;
